/**
 * Formats a number as a currency string.
 * @param value number to format
 */
export function formatDollar(value: number) {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'standard',
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatAbbreviatedDollar(value: number) {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
  }).format(value)
}

export function convertStringToNumber(value: string | number): number {
  if (!value) return 0
  const sanitizedValue = String(value)
    .replace(/[^0-9.-]/g, '')
    .replace(/^0+(?=\d)/, '')
  return parseFloat(sanitizedValue)
}

export function sum(values: Array<string | number>): number {
  return values
    .map((value) => convertStringToNumber(value))
    .reduce((acc, curr) => acc + curr, 0)
}

export function formatAbbreviatedNumber(value: number) {
  return Intl.NumberFormat('en-US', {
    currency: 'USD',
    notation: 'compact',
  }).format(value)
}
